import { DropDownInput } from "../../../components/_input/_dropdown";
import { Fragment, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import axios from "axios";
import config from "../../../configuration/config";

export const HomeSearch = () => {
    const { t: trans, i18n } = useTranslation(["common", "finance", "model", "home"]);
    const lang = i18n.language || "ar";
    const history = useHistory();

    const [brands, setBrands] = useState([]);
    const [groups, setGroups] = useState([]);
    const [subCategories, setSubCategories] = useState([]);

    const [fGroups, setFGroups] = useState([]);
    const [fSubCategories, setFSubCategories] = useState([]);

    const [modelSearch, setModelSearch] = useState({
        brandID: "",
        groupID: "",
        subCategoryID: "",
    });

    useEffect(() => {
        axios
            .request({
                baseURL: config.controllURL,
                url: lang + "/api/finance/index",
                method: "get",
            })
            .then((response) => {
                const result = response.data;
                const customizedBrands = result?.brands?.map((row) => ({
                    value: row.BrandID,
                    text: row.Description,
                }));
                setBrands(customizedBrands || []);
                setGroups(result?.groups || []);
                setSubCategories(result?.modelTypes || []);
            })
            .catch((err) => {
                console.error("Error fetching search data:", err);
            });
    }, [lang]);

    const handleFilterGroups = (brandID) => {
        if (groups) {
            const filteredValues = groups.filter((e) => 
                e.BrandId === brandID && 
                !e.Description?.toLowerCase().includes("test")
            );

            // Group by description and keep only the entry with the highest year
            const latestGroups = Object.values(
                filteredValues.reduce((acc, current) => {
                    const desc = current.Description?.trim();
                    if (!acc[desc] || parseInt(current.Year) > parseInt(acc[desc].Year)) {
                        acc[desc] = current;
                    }
                    return acc;
                }, {})
            );

            setFGroups(
                latestGroups.map((e) => ({
                    value: e.ProductGroupId,
                    text: `${e.Description} ${e.Year}`,
                    label: (
                        <Fragment>
                            {e.Description} <span style={{ color: '#23cc4f', marginInlineStart: '8px' }}>{e.Year}</span>
                        </Fragment>
                    )
                }))
            );
        }
    };

    const handleFilterSubCategories = (groupID) => {
        if (subCategories) {
            const filteredValues = subCategories.filter((e) => e.ProductGroupId === groupID);
            setFSubCategories(
                filteredValues.map((e) => ({
                    value: e.ProductTypeId,
                    text: e.Description,
                    modelCode: e.ModelCode
                }))
            );
        }
    };

    const handleSearch = () => {
        const queryParams = new URLSearchParams();
        let q = "";

        if (modelSearch.brandID) {
            const brand = brands.find((b) => b.value === modelSearch.brandID);
            if (brand) {
                q = brand.text;
                queryParams.set("brandID", modelSearch.brandID);
                queryParams.set("brandText", brand.text);
            }
        }

        if (modelSearch.groupID) {
            queryParams.set("groupID", modelSearch.groupID);
            const group = fGroups.find((g) => g.value === modelSearch.groupID);
            if (group) {
                queryParams.set("groupText", group.text);
                if (!q) q = group.text;
            }
        }

        if (modelSearch.subCategoryID) {
            queryParams.set("typeID", modelSearch.subCategoryID);
            const sub = fSubCategories.find((s) => s.value === modelSearch.subCategoryID);
            if (sub) {
                queryParams.set("typeText", sub.text);
                if (sub.modelCode) queryParams.set("modelCode", sub.modelCode);
                if (!q) q = sub.text;
            }
        }

        if (q) queryParams.set("q", q);
        queryParams.set("fromHome", "true");

        const qs = queryParams.toString();
        history.push(`/search${qs ? "?" + qs : ""}`);
    };

    return (
        <div className="search-sec">
            <div className="ctn">
                <div className="search-card rv on">
                    <div className="search-tabs">
                        <button className="sbt on">{trans("home:all_vehicles") || "All Vehicles"}</button>
                    </div>
                    <div className="search-row">
                        <div className="sf-group">
                            <DropDownInput
                                title={trans("finance:trade_mark")}
                                placeholder={trans("finance:select_brand")}
                                options={brands}
                                selectedValue={modelSearch.brandID}
                                onSelect={(val) => {
                                    const newSearch = {
                                        ...modelSearch,
                                        brandID: val,
                                        groupID: "",
                                        subCategoryID: "",
                                    };
                                    setModelSearch(newSearch);
                                    setFGroups([]);
                                    setFSubCategories([]);
                                    if (val) handleFilterGroups(val);
                                }}
                            />
                        </div>

                        <div className="sf-group">
                            <DropDownInput
                                title={trans("finance:group")}
                                placeholder={trans("finance:select_group")}
                                options={fGroups}
                                selectedValue={modelSearch.groupID}
                                disabled={!modelSearch.brandID}
                                onSelect={(val) => {
                                    const newSearch = {
                                        ...modelSearch,
                                        groupID: val,
                                        subCategoryID: "",
                                    };
                                    setModelSearch(newSearch);
                                    setFSubCategories([]);
                                    if (val) handleFilterSubCategories(val);
                                }}
                            />
                        </div>

                        <div className="sf-group">
                            <DropDownInput
                                title={trans("finance:sub_category")}
                                placeholder={trans("finance:select_model")}
                                options={fSubCategories}
                                selectedValue={modelSearch.subCategoryID}
                                disabled={!modelSearch.groupID}
                                onSelect={(val) => {
                                    setModelSearch({ ...modelSearch, subCategoryID: val });
                                }}
                            />
                        </div>

                        <button className="search-btn" onClick={handleSearch}>
                            <svg viewBox="0 0 24 24">
                                <circle cx="11" cy="11" r="8" />
                                <line x1="21" y1="21" x2="16.65" y2="16.65" />
                            </svg>
                            {trans("common:search")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
